<ng-container *ngrxLet="timelineData$ as timelineData">
  <ng-container *ngrxLet="ownerShipData$ as ownerShipData">
    <ng-container *ngrxLet="statuses$ as statuses">
      <div class="tasks h-100" *ngrxLet="severityData$ as severityData">
        @if ((isLoading$ | async) || !statuses) {
          <div class="section tasks-info">
            <div class="status-block">
              <p class="title">
                {{ "TASKS.STATUS" | translate }}
              </p>
              <div class="d-flex text-white row-container px-0">
                <app-circle-progress [size]="150"></app-circle-progress>
              </div>
            </div>
            <div>
              <div class="flex-grow-1">
                <p class="title">
                  {{ "TASKS.TASK_PRIORITY" | translate }}
                </p>
                <div
                  class="d-flex flex-column text-white risk-container row-container px-0 number-statistic"
                >
                  @for (label of severityLabels; track label) {
                    <div class="d-flex ps-2 statistic-info disabled">
                      <span class="number-info {{ label.className }}">-</span>
                      <p>{{ SeverityLabels[label.name] }}</p>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div>
              <div>
                <p class="title text-truncate">
                  {{ "TASKS.IMPLEMENTATION_TIMELINE" | translate }}
                </p>
                <div
                  [class.number-statistic-large]="timelineData.isLarge"
                  class="d-flex flex-column timeline-container row-container justify-content-between px-0 number-statistic"
                >
                  @for (label of timelineLabels; track label) {
                    <div class="d-flex ps-2 statistic-info disabled">
                      <span class="number-info {{ label.className }}">-</span>
                      <p>{{ ImplementationTimelineLabels[label.name] }}</p>
                    </div>
                  }
                </div>
              </div>
            </div>

            <div class="ownership-container">
              <p class="title">
                {{ "TASKS.OWNERSHIP" | translate }}
              </p>
              <div
                class="d-flex flex-column text-white risk-container row-container px-0 number-statistic"
              >
                @for (label of loadingOwnershipData; track label) {
                  <div class="d-flex ps-2 statistic-info disabled">
                    <span class="number-info">-</span>
                    <p>{{ label | titlecase }}</p>
                  </div>
                }
              </div>
            </div>

            <div>
              <p class="title">
                {{ "TASKS.ASSIGNED_ROLES" | translate }}
              </p>
              <div class="d-flex text-white row-container px-0">
                <app-circle-progress [size]="150"></app-circle-progress>
              </div>
            </div>
          </div>
        } @else {
          <ng-container *ngrxLet="taskFilters$ as taskFilters">
            <div
              *ngrxLet="getAvailabilityOfFilters$ as filtersAvailability"
              class="section tasks-info"
            >
              <div
                class="status-block"
                *ngrxLet="statusDistribution$ as statusData"
              >
                <p class="title">
                  {{ "TASKS.STATUS" | translate }}
                </p>
                <div class="d-flex text-white row-container px-0">
                  @if (!(isTasksEmpty$ | async) || statusData) {
                    <app-circle-progress
                      [data]="statusData"
                      [size]="150"
                    ></app-circle-progress>

                    <div>
                      <div class="circle-data-container status-container">
                        @for (item of statusData; track item.id) {
                          <div
                            (click)="
                              onFilterChange(
                                taskFilters,
                                'statuses',
                                item.id,
                                item.name,
                                !filtersAvailability.statuses[item.id]
                              )
                            "
                            class="circle-data-item align-items-center"
                            [class.disabled]="
                              !filtersAvailability.statuses[item.id]
                            "
                            [class.filter-selected]="
                              filterSelected(taskFilters, 'statuses', item.id)
                            "
                          >
                            <div
                              [style.background-color]="item.color"
                              class="colored-circle"
                            ></div>
                            <span>{{ item.name | splitByUpperCase }}</span>
                            <svg-icon [name]="'cross'"></svg-icon>
                          </div>
                        }
                      </div>
                    </div>
                  } @else {
                    <div class="d-flex text-white row-container px-0">
                      <app-circle-progress [size]="150"></app-circle-progress>
                    </div>
                  }
                </div>
              </div>
              <div>
                <p class="title">
                  {{ "TASKS.TASK_PRIORITY" | translate }}
                </p>
                <div
                  [class.number-statistic-large]="severityData.isLarge"
                  class="d-flex flex-column text-white risk-container row-container px-0 number-statistic"
                >
                  @for (label of severityLabels; track label) {
                    <div
                      (click)="
                        onFilterChange(
                          taskFilters,
                          'severity',
                          label.value,
                          SeverityLabels[label.name],
                          !filtersAvailability.severity[label.value]
                        )
                      "
                      class="d-flex ps-2 statistic-info"
                      [class.disabled]="
                        !filtersAvailability.severity[label.value]
                      "
                      [class.filter-selected]="
                        filterSelected(taskFilters, 'severity', label.value)
                      "
                      [class.filter-selected-number]="
                        filterSelected(taskFilters, 'severity', label.value)
                      "
                      [style.cursor]="
                        severityData.items[label.name] ? 'pointer' : 'default'
                      "
                    >
                      @if (severityData.items[label.name]) {
                        <span
                          [class.number-info-large]="severityData.isLarge"
                          class="number-info {{ label.className }}"
                        >{{ severityData.items[label.name] }}</span
                        >
                      } @else {
                        <mat-icon class="checkmark">check</mat-icon>
                      }
                      <p [class.disabled]="!severityData.items[label.name]">
                        {{ SeverityLabels[label.name] }}
                      </p>
                      @if (true) {
                        <svg-icon [name]="'cross'"></svg-icon>
                      }
                    </div>
                  }
                </div>
              </div>
              <div>
                <p class="title text-truncate">
                  {{ "TASKS.IMPLEMENTATION_TIMELINE" | translate }}
                </p>
                <div
                  [class.number-statistic-large]="timelineData.isLarge"
                  class="d-flex flex-column timeline-container row-container justify-content-between px-0 number-statistic"
                >
                  @for (label of timelineLabels; track label) {
                    <div
                      (click)="
                        onFilterChange(
                          taskFilters,
                          'implementationTimeline',
                          label.value,
                          ImplementationTimelineLabels[label.name],
                          !filtersAvailability.implementationTimeline[
                            label.value
                          ]
                        )
                      "
                      class="d-flex ps-2 statistic-info"
                      [class.disabled]="
                        !filtersAvailability.implementationTimeline[label.value]
                      "
                      [class.filter-selected]="
                        filterSelected(
                          taskFilters,
                          'implementationTimeline',
                          label.value
                        )
                      "
                      [class.filter-selected-number]="
                        filterSelected(
                          taskFilters,
                          'implementationTimeline',
                          label.value
                        )
                      "
                      [style.cursor]="
                        timelineData.items[label.name] ? 'pointer' : 'default'
                      "
                    >
                      @if (timelineData.items[label.name]) {
                        <span class="number-info {{ label.className }}">{{
                            timelineData.items[label.name]
                          }}</span>
                      } @else {
                        <mat-icon class="checkmark">check</mat-icon>
                      }
                      <p [class.disabled]="!timelineData.items[label.name]">
                        {{ ImplementationTimelineLabels[label.name] }}
                      </p>
                      <svg-icon [name]="'cross'"></svg-icon>
                    </div>
                  }
                </div>
              </div>
              <div>
                <p class="title text-truncate">
                  {{ "TASKS.OWNERSHIP" | translate }}
                </p>
                <div
                  [class.number-statistic-large]="ownerShipData.isLarge"
                  class="d-flex flex-column timeline-container row-container justify-content-between px-0 number-statistic"
                >
                  @for (label of ownershipLabels; track label) {
                    <div
                      (click)="
                        onFilterChange(
                          taskFilters,
                          'ownership',
                          label.name,
                          OwnershipLabels[label.name],
                          !filtersAvailability.ownership[label.name]
                        )
                      "
                      class="d-flex ps-2 statistic-info"
                      [class.disabled]="
                        !filtersAvailability.ownership[label.name]
                      "
                      [class.filter-selected]="
                        filterSelected(taskFilters, 'ownership', label.name)
                      "
                      [class.filter-selected-number]="
                        filterSelected(taskFilters, 'ownership', label.name)
                      "
                      [style.cursor]="
                        ownerShipData.items[label.name] ? 'pointer' : 'default'
                      "
                    >
                      @if (ownerShipData.items[label.name]) {
                        <span class="number-info">{{
                            ownerShipData.items[label.name]
                          }}</span>
                      } @else {
                        <mat-icon class="checkmark">check</mat-icon>
                      }
                      <p [class.disabled]="!ownerShipData.items[label.name]">
                        {{ OwnershipLabels[label.name]! }}
                      </p>
                      @if (true) {
                        <svg-icon [name]="'cross'"></svg-icon>
                      }
                    </div>
                  }
                </div>
              </div>
              <div *ngrxLet="assignedRoles$ as assignedRoles">
                <p class="title">
                  {{ "TASKS.ASSIGNED_ROLES" | translate }}
                </p>
                @if (assignedRoles && assignedRoles.length > 5) {
                  <div class="text-white row-container px-0 assigned-roles-row">
                    @if (assignedRoles) {
                      <app-circle-progress
                        [data]="assignedRoles"
                        [size]="150"
                        [noSpacing]="true"
                      ></app-circle-progress>
                    }
                    <div class="assigned-roles-ledger">
                      <div class="assigned-roles-column">
                        @for (item of assignedRoles.slice(0, 5);
                          track item.id) {
                          <div
                            (click)="
                              onFilterChange(
                                taskFilters,
                                'assignedRoles',
                                item.id,
                                item.name,
                                !filtersAvailability.assignedRoles[item.id]
                              )
                            "
                            class="circle-data-item assigned-roles-item align-items-center"
                            [class.disabled]="
                              !filtersAvailability.assignedRoles[item.id]
                            "
                            [class.filter-selected]="
                              filterSelected(
                                taskFilters,
                                'assignedRoles',
                                item.id
                              )
                            "
                          >
                            <div
                              [style.background-color]="item.color"
                              class="colored-circle"
                            ></div>
                            <div class="assigned-roles-label-wrap">
                              <span
                                class="assigned-roles-label"
                                [title]="item.name"
                                [appTruncateOverflowText]="item.name"
                              ></span>
                              @if (filterSelected(
                                taskFilters,
                                "assignedRoles",
                                item.id
                              )) {
                                <svg-icon
                                  class="assigned-roles-filter-clear"
                                  [name]="'cross'"
                                ></svg-icon>
                              }
                            </div>
                          </div>
                        }
                      </div>
                      <div class="assigned-roles-column">
                        @for (item of assignedRoles.slice(5);
                          track item.id) {
                          <div
                            (click)="
                              onFilterChange(
                                taskFilters,
                                'assignedRoles',
                                item.id,
                                item.name,
                                !filtersAvailability.assignedRoles[item.id]
                              )
                            "
                            class="circle-data-item assigned-roles-item align-items-center"
                            [class.disabled]="
                              !filtersAvailability.assignedRoles[item.id]
                            "
                            [class.filter-selected]="
                              filterSelected(
                                taskFilters,
                                'assignedRoles',
                                item.id
                              )
                            "
                          >
                            <div
                              [style.background-color]="item.color"
                              class="colored-circle"
                            ></div>
                            <div class="assigned-roles-label-wrap">
                              <span
                                class="assigned-roles-label"
                                [title]="item.name"
                                [appTruncateOverflowText]="item.name"
                              ></span>
                              @if (filterSelected(
                                taskFilters,
                                "assignedRoles",
                                item.id
                              )) {
                                <svg-icon
                                  class="assigned-roles-filter-clear"
                                  [name]="'cross'"
                                ></svg-icon>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                } @else {
                  <div class="d-flex text-white row-container px-0">
                    @if (assignedRoles) {
                      <app-circle-progress
                        [data]="assignedRoles"
                        [size]="150"
                      ></app-circle-progress>
                    }
                    @if (assignedRoles?.length) {
                      <div class="circle-data-container assigned-roles-container">
                        @for (item of assignedRoles; track item.id) {
                          <div
                            (click)="
                              onFilterChange(
                                taskFilters,
                                'assignedRoles',
                                item.id,
                                item.name,
                                !filtersAvailability.assignedRoles[item.id]
                              )
                            "
                            class="circle-data-item align-items-center"
                            [class.disabled]="
                              !filtersAvailability.assignedRoles[item.id]
                            "
                            [class.filter-selected]="
                              filterSelected(
                                taskFilters,
                                'assignedRoles',
                                item.id
                              )
                            "
                          >
                            <div
                              [style.background-color]="item.color"
                              class="colored-circle"
                            ></div>
                            <span>{{ item.name }}</span>
                            <svg-icon [name]="'cross'"></svg-icon>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </ng-container>
        }
        <div class="section flex-grow-1">
          <app-tasks></app-tasks>
        </div>
        <ng-container *ngrxLet="getTaskDetails$ as taskDetails">
          <app-details-sidebar
            (outsideClick)="hideSidebar()"
            [isOpen]="!!(showSidebar$ | async)"
            [isLoading]="(detailsLoading$ | async) || false"
            [loadingHeaderTemplate]="loadingHeaderTemplate"
          >
            <ng-template #loadingHeaderTemplate>
              <div class="sidebar sidebar-title-container">
                <div>
                  <div class="sidebar-title">
                    <div class="text-truncate">{{ taskDetails?.taskName }}</div>
                    <span class="sidebar-close" (click)="hideSidebar()"
                    >&#x2715;</span
                    >
                  </div>
                  <div class="sidebar-subtitle text-truncate">
                    {{ taskDetails?.asset?.name }}
                  </div>
                </div>
                @if (taskDetails.taskStatus === TaskStatusEnum.completed) {
                  <div class="task-status">
                    <svg-icon name="check-circle"></svg-icon>
                    <div class="task-status-text task-status-completed">
                    {{ taskDetails.taskStatus | taskStatusPipe }}
                    </div>
                  </div>
                } @else if(taskDetails.isBlockedByPrerequisites || taskDetails.taskLocked || taskDetails.isBlocked) {
                <div class="task-status">
                  <svg-icon name="warning-triangle"></svg-icon>
                  <div class="task-status-text">
                    {{ "TASKS.SIDEBAR.STATUS_BLOCKED" | translate }}
                  </div>
                </div>
                } @else {
                  <div class="d-flex justify-content-between task-status-text">
                    <div class="">
                      {{ taskDetails.taskStatus | taskStatusPipe }}
                    </div>
                    <div class="d-flex justify-content-start">
                      <div class="due-by-text">
                        {{ "TASKS.SIDEBAR.DUE_BY" | translate }}: &nbsp;
                      </div>
                      <div
                        [class.text-red]="
                          taskDetails?.implementationTimeline ===
                          ImplementationTimelineEnum.overdue
                        "
                      >
                        {{
                          taskDetails?.dueBy || "" | momentPipe: "MMMM Do, YYYY"
                        }}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </ng-template>
            @if (!!(showSidebar$ | async) && taskDetails) {
              <div class="sidebar sidebar-title-container">
                <div>
                  <div class="sidebar-title">
                    <div class="text-truncate">{{ taskDetails?.taskName }}</div>
                    <span class="sidebar-close" (click)="hideSidebar()"
                    >&#x2715;</span
                    >
                  </div>
                  <div class="sidebar-subtitle text-truncate">
                    {{ taskDetails?.asset?.name }}
                  </div>
                </div>
                @if (taskDetails.taskStatus === TaskStatusEnum.completed) {
                  <div class="task-status">
                    <svg-icon name="check-circle"></svg-icon>
                    <div class="task-status-text task-status-completed">
                      {{ taskDetails.taskStatus | taskStatusPipe }}
                    </div>
                  </div>
                } @else if(taskDetails.isBlockedByPrerequisites || taskDetails.taskLocked || taskDetails.isBlocked) {
                  <div class="task-status">
                    <svg-icon name="warning-triangle"></svg-icon>
                    <div class="task-status-text">
                      {{ "TASKS.SIDEBAR.STATUS_BLOCKED" | translate }}
                    </div>
                  </div>
                } @else {
                  <div class="d-flex justify-content-between task-status-text">
                    <div class="">
                      {{ taskDetails.taskStatus | taskStatusPipe }}
                    </div>
                    <div class="d-flex justify-content-start">
                      <div class="due-by-text">
                        {{ "TASKS.SIDEBAR.DUE_BY" | translate }}: &nbsp;
                      </div>
                      <div
                        [class.text-red]="
                          taskDetails?.implementationTimeline ===
                          ImplementationTimelineEnum.overdue
                        "
                      >
                        {{
                          taskDetails?.dueBy || "" | momentPipe: "MMMM Do, YYYY"
                        }}
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="sidebar-content d-flex flex-column p-0">
                <div appCustomScrollbarV2 class="py-3">
                  @if (taskDetails.actionBox.visible) {
                    <div class="blocked-action-box">
                      <div class="blocked-action-box-title">
                        {{ JSON.parse(taskDetails.actionBox.messageId | systemErrors).Title }}
                      </div>
                      <div class="blocked-action-box-list">
                        <div class="blocked-action-box-item">
                          {{
                            JSON.parse(taskDetails.actionBox.messageId | systemErrors: taskDetails.actionBox.messageArgs).Content
                          }}
                        </div>
                        @for (dependency of taskDetails.blockingPrerequisiteTasks;
                          track dependency.taskId || dependency.taskName) {
                          <div class="blocked-action-box-item">
                            <div class="blocked-action-box-task text-truncate">
                              • {{ dependency.taskName }}
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <div class="sidebar-top-bar">
                    <div class="sidebar-top-bar-content">
                      <div
                        [class.sidebar-top-bar-content-status-completed]="
                          taskDetails.taskStatus === TaskStatusEnum.completed
                        "
                        class="sidebar-top-bar-content-status sidebar-top-bar-content-status-{{
                          taskDetails!.severity!
                            | severityStatusPipe
                            | lowercase
                        }}"
                      >
                        <div>
                          {{ taskDetails.severity! | severityStatusPipe }}
                        </div>
                      </div>
                      <div class="d-flex justify-content-start w-100 z-0">
                        <div class="tab-container" style="gap: 5px">
                          <div class="tab-title">
                            {{ "TASKS.SIDEBAR.SIMILAR_TASKS" | translate }}
                          </div>
                          <div class="tab-pill">
                            <app-rounded-pill
                              [height]="22"
                              mode="light"
                              [isClickable]="false"
                              [total]="taskDetails.totalSimilarTasks"
                              [current]="
                                taskDetails.totalSimilarTasksInstatusClose
                              "
                            ></app-rounded-pill>
                          </div>
                        </div>
                        <div class="tab-container">
                          <div class="tab-title">
                            {{ "TASKS.SIDEBAR.REFERENCES" | translate }}
                          </div>
                          <div class="tab-content">
                            <span>{{
                                taskDetails.taskReferences.length || 0
                              }}</span>
                            <mat-icon
                              class="tab-content-icon"
                              (click)="scrollToSection('references')"
                            >remove_red_eye
                            </mat-icon
                            >
                          </div>
                        </div>
                        <div class="tab-container">
                          <div class="tab-title">
                            {{ "TASKS.SIDEBAR.STAKEHOLDERS" | translate }}
                          </div>
                          <div
                            class="tab-content"
                            [class.justify-content-start]="
                              !stakeholdersInfo.isCurrentUserInStakeholders
                            "
                            *ngrxLet="stakeholdersInfo$ as stakeholdersInfo"
                          >
                            @if (stakeholdersInfo.isCurrentUserInStakeholders) {
                              <span>
                                {{ "TASKS.SIDEBAR.YOU" | translate }} +
                                {{ stakeholdersInfo.stakeholdersCount }}
                              </span>
                            } @else {
                              <div class="w-50"></div>
                              <span style="margin-left: -5px">
                                {{ stakeholdersInfo.stakeholdersCount }}
                              </span>
                            }
                            <mat-icon
                              class="tab-content-icon"
                              (click)="scrollToSection('stakeholders')"
                            >remove_red_eye
                            </mat-icon
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="sidebar-bottom-bar h-100">
                      <div class="sidebar-bottom-bar-section">
                        <div class="sidebar-bottom-bar-section-title">
                          {{ "TASKS.SIDEBAR.DESCRIPTION" | translate }}
                        </div>
                        <div
                          class="sidebar-bottom-bar-section-content"
                          [innerHTML]="taskDetails.taskDescription | safeHtml"
                        ></div>
                      </div>
                      <div class="sidebar-bottom-bar-section">
                        <div class="sidebar-bottom-bar-section-title">
                          {{ "TASKS.SIDEBAR.REMEDIATION_STEPS" | translate }}
                        </div>
                        @if (taskDetails.remediationSteps) {
                          <div
                            class="sidebar-bottom-bar-section-content"
                            [innerHTML]="
                              taskDetails.remediationSteps | safeHtml
                            "
                          ></div>
                        } @else {
                          <div class="sidebar-bottom-bar-section-content">
                            <span class="d-flex justify-content-center">
                              {{ "NO_DATA" | translate }}
                            </span>
                          </div>
                        }
                      </div>
                      <div
                        class="sidebar-bottom-bar-section"
                        #stakeholdersSection
                        [class.highlight]="highlightSection === 'stakeholders'"
                      >
                        <app-stakeholders-info
                          [stakeholders]="taskDetails.tasksStakeholders"
                        ></app-stakeholders-info>
                      </div>
                      <div
                        class="sidebar-bottom-bar-section"
                        #referencesSection
                        [class.highlight]="highlightSection === 'references'"
                      >
                        <div class="sidebar-bottom-bar-section-title">
                          {{ "TASKS.SIDEBAR.REFERENCES" | translate }}
                        </div>
                        <div class="sidebar-bottom-bar-section-content">
                          @if (!taskDetails.taskReferences ||
                          taskDetails.taskReferences.length === 0) {
                            <span class="d-flex justify-content-center">{{
                                "NO_DATA" | translate
                              }}</span>
                          }
                          <div
                            class="sidebar-bottom-bar-section-content-wrapper"
                          >
                            <app-show-more-list>
                              <ng-template [appShowMoreItemOf]="taskDetails.taskReferences" let-reference let-isLast="last">
                                <div
                                  class="sidebar-bottom-bar-section-content-item"
                                  [class.border-0]="isLast"
                                  [class.sidebar-bottom-bar-section-content-item-bold]="
                                    reference.referenceType ===
                                    ReferenceTypeEnum.RISK
                                  "
                                >
                                  <div class="role-position d-flex gap-10">
                                    <div class="reference-status">
                                      @if (reference.statusIcon) {
                                        @switch (reference.statusIcon) {
                                          @case ('Timer') {
                                            <svg-icon
                                              height="17px"
                                              width="17px"
                                              fill="var(--color-high-warning-text)"
                                              name="quarter-icon"
                                            ></svg-icon>
                                          }
                                          @case ('Completed') {
                                            <svg-icon
                                              name="check-circle"
                                            ></svg-icon>
                                          }
                                          @case ('InProcess') {
                                            <svg-icon name="in-progress"></svg-icon>
                                          }
                                          @case ('Warning') {
                                            <svg-icon name="warning-triangle"></svg-icon>
                                          }
                                          @case ('Information') {
                                            <svg-icon name="warning-circle"></svg-icon>
                                          }
                                        }
                                      } @else {
                                        @if (reference.referenceType ===
                                        ReferenceTypeEnum.RISK) {
                                          @if (reference.status ===
                                          RiskStatus.OPEN_RISK ||
                                          reference.status ===
                                          RiskStatus.WAITING_FOR_REMOVAL) {
                                            <svg-icon name="in-progress"></svg-icon>
                                          } @else if (reference.status ===
                                          RiskStatus.MITIGATION) {
                                            <svg-icon
                                              name="check-circle"
                                            ></svg-icon>
                                          } @else {
                                            <svg-icon
                                              name="warning-triangle"
                                            ></svg-icon>
                                          }
                                        } @else {
                                          @if (reference.status === PolicyStatus.ACTIVE) {
                                            <svg-icon
                                              name="check-circle"
                                            ></svg-icon>
                                          } @else if (reference.status ===
                                          PolicyStatus.ACTIVE_PARTIAL) {
                                            <svg-icon
                                              name="warning-triangle"
                                            ></svg-icon>
                                          } @else if (reference.status ===
                                          PolicyStatus.ACTIVE_CHANGED) {
                                            <svg-icon
                                              name="warning-circle"
                                            ></svg-icon>
                                          } @else {
                                            <svg-icon name="in-progress"></svg-icon>
                                          }
                                        }
                                      }

                                    </div>
                                    <div>
                                      {{
                                        reference.referenceType ===
                                        ReferenceTypeEnum.RISK
                                          ? "Risk"
                                          : "Policy"
                                      }}
                                    </div>
                                  </div>
                                  <div class="align-self-end text-truncate">
                                    {{ reference.name }}
                                  </div>
                                </div>
                              </ng-template>
                            </app-show-more-list>
                          </div>
                        </div>
                      </div>
                      <div class="sidebar-bottom-bar-section">
                        <div class="sidebar-bottom-bar-section-title">
                          {{ "TASKS.SIDEBAR.COMMENTS" | translate }}
                          {{
                            taskDetails.comments?.length
                              ? "(" + taskDetails.comments?.length + ")"
                              : ""
                          }}
                        </div>
                        <app-comments
                          [comments]="taskDetails.comments"
                          [commentControl]="commentControl"
                          [commentPending]="
                            taskDetails.taskDetailsCommentPending ?? false
                          "
                          [commentFailed]="
                            taskDetails.taskDetailsCommentFailed ?? false
                          "
                          [newComment]="taskDetails.newComment"
                          [errorMessage]="taskDetails.commentErrorMessage"
                          (onAddComment)="
                            addComment(taskDetails.taskId, $event)
                          "
                          (hideFailedCommentEvent)="hideFailedComment()"
                        ></app-comments>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </app-details-sidebar>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
